/**
 * 路由异常拦截：任意路由 API 跳转失败（页面不存在、路径写错等）统一兜底回首页
 */
import { onRouteFail } from './utils.js';

const ROUTE_APIS = ['navigateTo', 'redirectTo', 'reLaunch', 'switchTab'];

export const routeInterceptor = {
    install() {
        ROUTE_APIS.forEach((api) => {
            // fail 回调不带 url，用 invoke 记录本次跳转目标
            let lastUrl = '';
            uni.addInterceptor(api, {
                invoke(args) {
                    lastUrl = args?.url || '';
                },
                fail(err) {
                    onRouteFail(err, lastUrl);
                }
            });
        });
    }
};

export default routeInterceptor;
